module.exports = __webpack_public_path__ + "img/6.2a21ce5.png";